export const Tabs = {
  baseStyle: {
    tablist: {
      gap: 4,
      justifyContent: "start",
      mb: 6,
    },
    tab: {
      color: "primary.midGrey",
      d: "inline-block",
      fontSize: "1.25rem",
      fontFeatureSettings: '"ss01" on, "ss02" on',
      lineHeight: 1.16,
      px: 10,
      py: 5,
      borderRadius: "32px",
      backgroundColor: "primary.white",
      _hover: {
        backgroundColor: "preset.purple",
      },
      _selected: {
        backgroundColor: "preset.purple",
      },
      _active: {
        backgroundColor: "preset.purple",
      },
    },
    tabpanel: {
      backgroundColor: "primary.white",
      p: 0,
    },
  },
  defaultProps: {
    size: "unset",
    variant: "unset",
  },
}
